import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChange,
  ViewEncapsulation,
} from '@angular/core';

import { forEach } from 'lodash';
import {
  XUXMenuPinnedService,
  XUXDrawerSidebarService,
} from '@app/xenial-ux/services';
import { IMenuItem } from '@app/xenial-ux/interfaces';
import { I18n } from '@app/i18n/strings-keys';

@Component({
  selector: 'xux-navigation',
  templateUrl: './xux-navigation.component.html',
  styleUrls: ['./xux-navigation.component.scss'],
  providers: [XUXMenuPinnedService],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class XUXNavigationComponent implements OnChanges {
  public I18n = I18n;

  public searchText: string;
  public managedItems: IMenuItem[];

  @Input() public menuItems: IMenuItem[];
  @Input() public hiddenMenu: boolean;
  @Output() public onTogglePin: EventEmitter<any> = new EventEmitter();

  public pinnedItems: IMenuItem[] = [];

  public constructor(
    private readonly menuPinnedService: XUXMenuPinnedService,
    private readonly drawerSidebarService: XUXDrawerSidebarService,
  ) {}

  public ngOnChanges(
    changes: Record<keyof XUXNavigationComponent, SimpleChange>,
  ): void {
    if (changes.menuItems) {
      this.managedItems = this.filterHiddenItems(this.menuItems);
      this.synchronizePins();
    }
  }

  protected synchronizePins(): void {
    const pinnedMenu: string[] = this.menuPinnedService.getPinnedMenu();
    this.pinnedItems = [];
    const setPinned = (item: IMenuItem): void => {
      if (pinnedMenu.indexOf(item.title) > -1) {
        item.pinned = true;
        this.pinnedItems.push({ ...item, isOpen: false });
      } else {
        item.pinned = false;
      }
      if (item.subItemsArray) {
        item.subItemsArray.forEach(setPinned);
      }
    };
    this.managedItems.forEach(setPinned);
  }

  public toggleSlide(): void {
    this.drawerSidebarService.toggle();
  }

  public togglePin(payload: any): void {
    this.menuPinnedService.togglePin(payload.menuItem);
    this.synchronizePins();
  }

  public closePopover(event: TouchEvent): void {
    if (!event) return;

    const hoverElement = event.currentTarget as HTMLElement;
    const popover = hoverElement.getElementsByClassName('popover-wrapper') as
      | HTMLCollection
      | undefined;
    forEach(popover, (el: HTMLElement) => (el.style.display = 'none'));
    event.stopPropagation();
  }

  private filterHiddenItems(items: IMenuItem[]): any {
    return items
      .filter((item) => !item.hidden)
      .map((menuItem) => {
        const item = { ...menuItem };
        if (item.subItemsArray) {
          item.subItemsArray = this.filterHiddenItems(item.subItemsArray);
        }

        return item;
      });
  }
}
